import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchRejectModalInitialState: IHomeMatchState["rejectModal"] = {
    isOpen: false,
    preleadId: null
};
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchRejectModalInitialState: IHomeMatchState["rejectModal"] = {
    isOpen: false,
    preleadId: null
};
